import React, { useEffect, useState } from "react";
import Header from "../master/SideBar.jsx";
import Nav from "../master/NavBar.jsx";
import { BatchlistBySession } from "../../api/BatchService.js";
import { getSessions } from "../../api/SessionsService.js";
import Swal from "sweetalert2";
import { closeModal, ToastMain, SweetAlertShow, LoadingDiv } from "../master/Master.jsx";
import Master from "./Master.jsx";
import { Link } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink.js";
import { handleStudentDownload } from "../student/components/Master.jsx";
import { courseList } from "../../api/Courses.js";
import { batchList } from "../../api/Batch.js";
import Pagination from "../components/Pagination.jsx";
import { followupAdd } from "../../api/FollowUps.js";
import { feeDepositList, feeDepositListV4 } from "../../api/FeesDeposite.js";
import FollowUpModal from "./FollowUpModel.jsx";
import { getFollowupsList } from "../enquiry/components/Master.jsx";


export default function FeeCollectionV2() {
    const hasAccess = usePrivateLink();
    const [filters, setFilters] = useState({
        session_id: "",
        type: "active",
        search: "",
        address: "",
        batch_id: "",
        start_date: "",
        end_date: "",
        sort_by: "",
        sort_order: "",
        category: "",
        gender: "",
    });
    const [selectedSession, setSelectedSession] = useState("");
    const [selectedBatch, setSelectedbatch] = useState("");
    const [batch, setBatch] = useState([]);
    const [error, setError] = useState("");
    const [data, setData] = useState([]);
    const [studentName, setStudentName] = useState("");
    const [loading, setLoading] = useState(false);
    const [followData, setFollowData] = useState([]);
    const [name, setName] = useState("");
    const [id, setId] = useState("");
    const [sessions, setSessions] = useState([]);
    const [batches, setBatches] = useState([]);
    const [courses, setCourses] = useState([]);
    const [modeldata, setmodeldata] = useState([]);


    const handleFunction = () => {
        getFollowupsList({
            setLoading,
            filters,
            setData,
        });
    };

    useEffect(() => {
        handleFunction();
    }, [filters]);

    const handleReset = () => {
        setSelectedSession("");
        setSelectedbatch("");
        setStudentName("");
        setData([]);
    };

    const getBatchList = async () => {
        setLoading(true);

        try {

            let params = [];

            if (filters?.course_id) {
                params.push(`course_id=${filters?.course_id}`);
            }

            if (filters?.session_id) {
                params.push(`session_id=${filters?.session_id}`);
            }

            const addUrl = params.join("&");

            const response = await batchList(addUrl);

            if (response.data.status) {
                setBatches(response?.data?.data || []);
            } else {
                SweetAlertShow("info", "Warning", response?.data?.message);
            }

        } catch (error) {

            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.response?.message ??
                error?.message
            );

        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        getBatchList();
    }, [filters?.course_id, filters?.session_id]);

    const courseFetch = async () => {
        setLoading(true);
        try {
            const response = await courseList();
            if (response.data.status) {
                setCourses(response?.data?.data || []);
            } else {
                SweetAlertShow("info", "Warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.response?.message ??
                error?.message,
            );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        courseFetch();
    }, []);

    useEffect(() => {
        const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
        setSessions(parseSessions);
    }, []);

    useEffect(() => {
        const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
        setFilters((prev) => {
            if (prev.session_id || !activeSession) return prev;
            return {
                ...prev,
                session_id: activeSession,
            };
        });
    }, [sessions]);

    const handleAdd = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const formData = new FormData(e.target);
            const response = await followupAdd(formData);
            if (response?.data?.status) {
                closeModal("feefollowup");
                e?.target?.reset();
                SweetAlertShow("success", "Successfully", response?.data?.message);
            } else {
                SweetAlertShow("info", "warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.response?.message ??
                error?.message
            );
        } finally {
            setLoading(false);
            getStudents();

        }
    };


    const getStudents = async () => {

        try {

            setLoading(true);

            let url = "";
            Object.entries(filters).forEach(([key, value]) => {
                if (value && key) {
                    url += `${key}=${value}&`;
                }
            });

            const response = await feeDepositList(url);

            console.log("Student Fee Deposit", response?.data);


            if (response?.data?.status) {

                setData(response?.data?.data);

                setError("");

            } else {

                setData([]);

                setError(
                    response?.data?.message ||
                    "Failed to fetch students."
                );
            }

        } catch (err) {

            setData([]);

            setError(
                err?.response?.data?.message ||
                "Something went wrong"
            );

            SweetAlertShow(
                "error",
                "Error",
                err?.response?.data?.message ??
                err?.message
            );

        } finally {

            setLoading(false);
        }
    };


    useEffect(() => {

        const delayDebounce = setTimeout(() => {

            getStudents();

        }, 500);

        return () => clearTimeout(delayDebounce);

    }, [
        filters,
    ]);

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (studentName.length > 0 || selectedBatch || selectedSession) {
                getStudents();
            }
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [studentName, selectedBatch, selectedSession]);

    return (
        <>
            {loading && <LoadingDiv />}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid flex-grow-1 container-p-y">
                                <div className="row">
                                    <Master />
                                    <div className="col-md-12 right-pane">

                                        <div className="card p-3 mb-3 shadow-sm border-0">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div
                                                        style={{
                                                            width: 45,
                                                            height: 45,
                                                            borderRadius: "12px",
                                                            background:
                                                                "linear-gradient(45deg,#185fa5,#4f8cff)",
                                                            color: "#fff",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <i className="ri-money-rupee-circle-line"></i>
                                                    </div>

                                                    <div>
                                                        <h5 className="m-0 fw-bold">Fee Deposit</h5>
                                                        <small>
                                                            Due Fees & Student Followups                                                          </small>
                                                    </div>
                                                </div>

                                                <div className="d-flex align-items-center gap-2">



                                                    <div className="d-flex flex-wrap gap-2 mb-3">
                                                        {/* SESSION */}
                                                        {filters.session_id && (
                                                            <span className="badge bg-primary-subtle text-primary px-3 py-2">
                                                                Session:{" "}
                                                                {
                                                                    sessions.find(
                                                                        (s) => s.id == filters.session_id,
                                                                    )?.session
                                                                }
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, session_id: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}

                                                        {/* SEARCH */}
                                                        {filters.search && (
                                                            <span className="badge bg-dark-subtle text-dark px-3 py-2">
                                                                Search: {filters.search}
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, search: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}



                                                        {/* BATCH */}
                                                        {filters.batch_id && (
                                                            <span className="badge bg-warning-subtle text-dark px-3 py-2">
                                                                Batch:{" "}
                                                                {
                                                                    batches.find((b) => b.id == filters.batch_id)
                                                                        ?.title
                                                                }
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, batch_id: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}

                                                        {/* DATE RANGE */}
                                                        {filters.start_date && (
                                                            <span className="badge bg-info-subtle text-info px-3 py-2">
                                                                From: {filters.start_date}
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, start_date: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}

                                                        {filters.end_date && (
                                                            <span className="badge bg-info-subtle text-info px-3 py-2">
                                                                To: {filters.end_date}
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, end_date: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}


                                                    </div>

                                                    <button
                                                        title="Open Filters"
                                                        className="btn btn-light border rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                        data-bs-toggle="offcanvas"
                                                        data-bs-target="#filterCanvas"
                                                        style={{ width: 40, height: 40 }}
                                                    >
                                                        <i className="ri-filter-3-line text-primary"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>




                                        <div className="card border-0 shadow-sm p-2">
                                            <div className="card-body p-0">
                                                <div className="d-flex justify-content-between align-items-center mb-3">

                                                    {/* Left Text */}
                                                    <h5 className="mb-0 fw-bold">
                                                        {/* Student Due Fees */}
                                                    </h5>

                                                    {/* Right Input */}
                                                    <div style={{ width: "350px" }}>
                                                        <div className="form-floating form-floating-outline">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Student Name/Mobile/Registration"
                                                                value={filters?.search}
                                                                onChange={(e) => {
                                                                    let value = e.target.value.toUpperCase();
                                                                    setFilters({ ...filters, search: value });
                                                                }}
                                                            />
                                                            <label>Name/Mobile/Reg. No</label>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="table-responsive">

                                                    <table
                                                        className="table align-middle mb-0 w-100"

                                                    >
                                                        <thead
                                                        >
                                                            <tr>
                                                                <th className="py-3 px-3 text-nowrap">#</th>

                                                                <th className="py-3 text-nowrap">
                                                                    NAME
                                                                </th>

                                                                <th className="py-3 text-nowrap">
                                                                    MOBILE
                                                                </th>

                                                                <th className="py-3 text-nowrap">
                                                                    BATCH
                                                                </th>

                                                                <th className="py-3 text-nowrap">
                                                                    ACTIVE SESSION
                                                                </th>

                                                                <th className="py-3 text-nowrap">
                                                                    All SESSION
                                                                </th>



                                                                <th className="py-3 text-nowrap text-center">
                                                                    NEXT PAYMENT
                                                                </th>

                                                                <th className="py-3 text-nowrap text-center">
                                                                    ACTION
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {data?.data?.length > 0 ? (
                                                                data?.data?.map((student, index) => {

                                                                    const fee = student?.summary || {};

                                                                    return (

                                                                        <tr key={student?.id}>

                                                                            <td className="px-3 py-2">
                                                                                {index + 1}
                                                                            </td>

                                                                            <td className="py-2">
                                                                                <div>
                                                                                    <Link
                                                                                        to={`/student/details?id=${student?.student_info?.id}`}
                                                                                        className="fw-semibold"
                                                                                    >
                                                                                        {student?.student_info?.name ?? ''}
                                                                                    </Link>
                                                                                </div>
                                                                            </td>

                                                                            <td className="py-2 text-nowrap">
                                                                                {student?.student_info?.phone ?? ''}
                                                                            </td>

                                                                            <td className="py-2 ">
                                                                                <div>
                                                                                    <small className="mb-0 small">
                                                                                        {student?.batch?.title ?? '-'}
                                                                                    </small>
                                                                                </div>
                                                                            </td>


                                                                            <td className="py-1 small">

                                                                                {Object.entries(student?.summary?.active || {})
                                                                                    .filter(([_, data]) => Number(data?.total ?? 0) > 0)
                                                                                    .map(([name, data], index) => (
                                                                                        <div
                                                                                            key={index}
                                                                                            className="d-flex justify-content-between align-items-center"
                                                                                        >

                                                                                            <div className="fw-semibold text-dark text-nowrap text-capitalize">
                                                                                                {name.replace("_", " ")} Fees :
                                                                                            </div>

                                                                                            <div className="d-flex align-items-center gap-3 flex-nowrap">

                                                                                                <span className="text-primary fw-semibold text-nowrap">
                                                                                                    ₹{Number(data?.total ?? 0).toFixed(2)}
                                                                                                </span>

                                                                                                <span className="text-success fw-semibold text-nowrap">
                                                                                                    ₹{Number(data?.paid ?? 0).toFixed(2)}
                                                                                                </span>

                                                                                                <span className="text-danger fw-semibold text-nowrap">
                                                                                                    ₹{Number(data?.pending ?? 0).toFixed(2)}
                                                                                                </span>

                                                                                            </div>

                                                                                        </div>
                                                                                    )
                                                                                    )}

                                                                            </td>

                                                                            <td className="py-1 small">

                                                                                {Object.entries(student?.summary?.active || {})
                                                                                    .filter(([_, data]) => Number(data?.total ?? 0) > 0)
                                                                                    .map(([name, data], index) => (
                                                                                        <div
                                                                                            key={index}
                                                                                            className="d-flex justify-content-between align-items-center"
                                                                                        >

                                                                                            <div className="fw-semibold text-dark text-nowrap text-capitalize">
                                                                                                {name.replace("_", " ")} Fees :
                                                                                            </div>

                                                                                            <div className="d-flex align-items-center gap-3 flex-nowrap">

                                                                                                <span className="text-primary fw-semibold text-nowrap">
                                                                                                    ₹{Number(data?.total ?? 0).toFixed(2)}
                                                                                                </span>

                                                                                                <span className="text-success fw-semibold text-nowrap">
                                                                                                    ₹{Number(data?.paid ?? 0).toFixed(2)}
                                                                                                </span>

                                                                                                <span className="text-danger fw-semibold text-nowrap">
                                                                                                    ₹{Number(data?.pending ?? 0).toFixed(2)}
                                                                                                </span>

                                                                                            </div>

                                                                                        </div>
                                                                                    )
                                                                                    )}

                                                                            </td>

                                                                            <td className="text-center py-2 text-nowrap">

                                                                                {student?.next_followup_date ?? "-"}

                                                                            </td>

                                                                            <td className="text-center py-2">

                                                                                <div className="d-flex justify-content-center gap-2">

                                                                                    <Link
                                                                                        to={`/student/fees/deposit?id=${student?.student_id}`}
                                                                                        className="btn btn-sm text-success bg-success-subtle border"
                                                                                    >
                                                                                        <i className="ri-money-rupee-circle-line"></i>
                                                                                    </Link>

                                                                                    <button
                                                                                        className="btn btn-sm text-warning bg-warning-subtle border"
                                                                                        data-bs-toggle="modal"
                                                                                        data-bs-target="#feefollowup"
                                                                                        onClick={() => {
                                                                                            // setmodeldata(student);
                                                                                            setmodeldata({
                                                                                                data: student,
                                                                                                student: student?.student_info,
                                                                                                followups: student?.student_info?.followups,
                                                                                            });

                                                                                            setId(student?.student_id);
                                                                                        }}
                                                                                    >
                                                                                        <i className="ri-customer-service-2-line"></i>
                                                                                        {/* FollowUp */}
                                                                                    </button>

                                                                                </div>

                                                                            </td>

                                                                        </tr>
                                                                    );
                                                                })

                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="8" className="text-center py-4 text-danger">
                                                                        No matching filter data found
                                                                    </td>
                                                                </tr>

                                                            )}



                                                        </tbody>
                                                    </table>

                                                    <Pagination data={data} setFilters={setFilters} filters={filters} />



                                                    <FollowUpModal
                                                        data={modeldata}
                                                        setLoading={setLoading}
                                                        handleFunction={handleFunction}
                                                    />

                                                </div>
                                            </div>
                                        </div>






                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div className="offcanvas offcanvas-end" tabIndex="-1" id="filterCanvas">
                {/* HEADER */}
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title"> Filters</h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                    ></button>
                </div>

                {/* BODY */}
                <div className="offcanvas-body">
                    <div className="row">

                        <div className="col-12 mb-3">
                            <div className="form-floating form-floating-outline ">
                                <select
                                    className="form-select"
                                    value={filters?.session_id}
                                    onChange={(e) => {
                                        setFilters({
                                            ...filters,
                                            session_id: e.target.value,
                                        });
                                    }}
                                >
                                    <option value="all">All</option>
                                    {sessions.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.session}:
                                            {Number(item.status) === 1 ? "Active" : "Inactive"}
                                        </option>
                                    ))}
                                </select>
                                <label>Filter Session</label>
                            </div>
                        </div>
                        <div className="col-12 mb-3">
                            <div className="form-floating form-floating-outline ">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Student Name/Mobile/Registration"
                                    value={filters?.search}
                                    onChange={(e) => {
                                        let value = e.target.value.toUpperCase();
                                        setFilters({ ...filters, search: value });
                                    }}
                                />
                                <label>Name/Mobile/Reg. No</label>
                            </div>
                        </div>





                        <div className="col-12 mb-3">
                            <div className="form-floating form-floating-outline ">
                                <select
                                    className="form-select"
                                    value={filters?.course_id}
                                    onChange={(e) => {
                                        setFilters({
                                            ...filters,
                                            course_id: e.target.value,
                                            batch_id: "",
                                        });
                                    }}
                                >
                                    <option value="">All Courses / Classes</option>
                                    {courses?.map((course, index) => (
                                        <option key={index} value={course.id}>
                                            {course.title}
                                        </option>
                                    ))}
                                </select>
                                <label>Course</label>
                            </div>
                        </div>

                        <div className="col-12 mb-3">
                            <div className="form-floating form-floating-outline ">
                                <select
                                    className="form-select"
                                    value={filters?.batch_id}
                                    onChange={(e) => {
                                        setFilters({
                                            ...filters,
                                            batch_id: e.target.value,
                                        });
                                    }}
                                >
                                    <option value="">Select Batch</option>
                                    {batches?.map((batch, i) => {
                                        const courseTitle = batch?.course?.title || "";
                                        const shortCourseTitle =
                                            courseTitle.length > 20
                                                ? courseTitle.substring(0, 20) + "..."
                                                : courseTitle;

                                        return (
                                            <option key={i} value={batch?.id}>
                                                {`${batch?.title} (${shortCourseTitle})`}
                                            </option>
                                        );
                                    })}
                                </select>
                                <label>Select Batch</label>
                            </div>
                        </div>




                        <div className="col-12 mb-3">
                            <div className="form-floating form-floating-outline ">
                                <input
                                    type="date"
                                    className="form-control"
                                    value={filters?.start_date}
                                    onChange={(e) => {
                                        setFilters({
                                            ...filters,
                                            start_date: e.target.value,
                                        });
                                    }}
                                />
                                <label>Admission From Date</label>
                            </div>
                        </div>




                    </div>

                    {/* BUTTONS SAME AS YOURS */}
                    <div className="row g-2 mt-3">
                        <div className="col-6">
                            <button
                                className="btn btn-primary w-100"
                                data-bs-dismiss="offcanvas"
                            >
                                Apply
                            </button>
                        </div>

                        <div className="col-6">
                            <button
                                className="btn btn-outline-danger w-100"
                                onClick={() =>
                                    setFilters({
                                        status: "",
                                        search: "",
                                        session_id: "",
                                        start_date: "",
                                        end_date: "",
                                        created_by: "",
                                        course_id: "",
                                        sort_by: "",
                                        sort_order: "",
                                    })
                                }
                            >
                                Reset
                            </button>
                        </div>


                        {hasAccess("/students/export") && (
                            <div className="col-4">
                                <button
                                    className="btn btn-outline-primary w-100"
                                    onClick={() =>
                                        handleStudentDownload("excel", setLoading, filters)
                                    }
                                >
                                    <i className="ri-file-excel-2-line"></i>
                                </button>
                            </div>
                        )}

                        {hasAccess("/students/print") && (
                            <div className="col-4">
                                <button
                                    className="btn btn-outline-danger w-100"
                                    onClick={() =>
                                        handleStudentDownload("print", setLoading, filters)
                                    }
                                >
                                    <i className="ri-printer-line"></i>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>







        </>
    );
}
